import React from 'react';
import { categories } from '../../content/commerce/itemCategories';
import { Item, MomsChange } from '../../containers/commerce';
import NormalItemDisplay from './NormalItemDisplay';
import PalleItemDisplay from './PalleItemDisplay';
import { Table, Tr, Th } from '../../components/tables';
import { Span, Paragraph } from '../../components/typography';

export default ({ name, isPalle }) => {
  if (!categories[name]) {
    // eslint-disable-next-line no-console
    console.log('Not existing category', name);
    return null;
  }
  const {
    headline,
    subHeadline,
    items,
  } = categories[name];
  const display = isPalle ? PalleItemDisplay : NormalItemDisplay;
  return (
    <React.Fragment>
      <Table striped1 marginBottom="5px">
        <thead>
          <Tr>
            <Th>
              {headline}<br />
              <Span>{subHeadline}</Span>
            </Th>
            <Th textRight>
              Antal
            </Th>
            <Th width="45px" textRight>
              Pr. stk.
            </Th>
            <Th width="45px" textRight>
              Pris
            </Th>
          </Tr>
        </thead>
        <tbody>
          {items.map(
            varenr => (
              <Item varenr={varenr} display={display} key={varenr} />
            ),
          )}
        </tbody>
      </Table>
      <Paragraph fontSize="12px">Priserne er <MomsChange /></Paragraph>
    </React.Fragment>
  );
};
